import React from "react";
import styled from "styled-components";
import lauryn_img from "./images/lauryn.png";
import image_eight from "./images/image8.png";
import image_seven from "./images/image7.png";
import { HashLink } from 'react-router-hash-link';
import {HashRouter} from 'react-router-dom';
import { colors, mediaQueries } from '../shared/config'


const Wrapper = styled.div`
    width: auto;
    background: ${colors.background};

    ${mediaQueries.mobile}{
        justify-content: center;
    }
`;

const Photocred = styled.div`
    font-family: Optima;
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 12px;
    display: flex;
    align-items: center;
    text-align: center;
    position: relative;
    margin-left: 70%;
    top: 90%;
    color: #FFFFFF;

    ${mediaQueries.mobile} {
        font-size: 7px;
        margin-left: 60%;
    }
`;


const Title = styled.div`
    display: flex;
    align-items: left;
    text-transform: uppercase;
    font-family: Optima;
    font-style: normal;
    font-weight: normal;
    font-size: 64px;
    line-height: 78px;
    color: #FFFFFF;
    left: 10%;
    position: relative;
    margin-top: 5%;

    ${mediaQueries.mobile}{
        text-align: center;
        align: center;
        justify-content: center;
        left: 0;
        font-size: 40px;
        line-height: 48px;
    }
`;

const Description = styled.div`
    position: relative;
    width: 60%;
    left: 10%;

    font-family: Optima;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 22px;
    display: flex;
    align-items: left;

    color: #FFFFFF;

    margin-top: 2rem;

    ${mediaQueries.mobile}{
        text-align: center;
        left: 20%;
        font-size: 13px;
        line-height: 17px;
    }
`;

const ImageWrapper = styled.div`
    position: relative;
    display:flex;
    align: center;
    align-items: center;
    justify-content: center;
    padding-top: 3%;
    width: 90%;
    margin: 0 auto;
    flex-flow: row wrap;
    ${mediaQueries.mobile}{
        justify-content: center;
        
    }
`;


const LeftImage = styled.div`
background-image: url(${image_eight});
background-repeat: no-repeat;
background-size: cover;
position: relative;
width: 40vw;
height: 55vh;
border-top: 1px solid white;
border-left: 1px solid white;
border-bottom: 1px solid white;
p {
    background-color: transparent;
    color: transparent;
    
}


${mediaQueries.mobile} {
    width: 20.16rem;
    height: 16rem;
    background-size: cover;
    border-right: 1px solid white;
    border-bottom: 0px;
}

&:hover {
    background-image: url(${image_eight});
    box-shadow: inset 0 0 0 50vw rgba(255, 255, 255, 0.87);
    // opacity: 0.60;

    p{
        padding: 25% 0;
            background-color: transparent;
            align-items: center;
            text-align: center;


            font-family: Optima;
            font-style: normal;
            font-weight: normal;
            font-size: 24px;

            /* identical to box height */


            text-transform: uppercase;
            color: black;
            font-color: black;
    }
`;




// &:hover {
//     background-color: lightblue;
// }



const RightImage = styled.div`
    background-image: url(${image_seven});
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    width: 40vw;
    height: 55vh;
    align-items: center;
    text-align: center;
    font-color: black;
    border-top: 1px solid white;
    border-right: 1px solid white;
    border-bottom: 1px solid white;
    p {
        background-color: transparent;
        color: transparent;
    }
    ${mediaQueries.mobile} {
        width: 20.16rem;
        height: 16rem;
        background-size: cover;
        border-left: 1px solid white;
    }

    &:hover {
        background-image: url(${image_seven});
        align-items: center;
        text-align: center;

        box-shadow: inset 0 0 0 50vw rgba(255, 255, 255, 0.87);
        // opacity: 0.60;
        font-color: black;
        p{
            padding: 25% 0;
            background-color: transparent;
            align-items: center;
            text-align: center;


            font-family: Optima;
            font-style: normal;
            font-weight: normal;
            font-size: 24px;

            /* identical to box height */


            text-transform: uppercase;
            color: black;
            font-color: black;
        }
`;



export default function Landing (props) {
    console.log("landig")
    console.log(props);
    return (props && props.data &&
        <Wrapper>
            <Title>
                This is March
            </Title>

            <Description>
            {props.data.intro_text}
            </Description>

            <ImageWrapper>
                <HashRouter>
                    <HashLink  to={"#women"}  style={{ textDecoration: 'none', color: 'black' }}>
                        <LeftImage>
                            <Photocred>
                                {props.data.women_landing_credits}
                            </Photocred>
                            <p>Women's Basketball</p>
                        </LeftImage>
                    </HashLink>


                    <HashLink  to={"#men"}  style={{ textDecoration: 'none', color: 'black' }}>
                        <RightImage>
                            <Photocred>
                            {props.data.men_landing_credits}
                            </Photocred>
                            <p>Men's Basketball</p>
                        </RightImage>
                    </HashLink>
                </HashRouter>
            </ImageWrapper>

        </Wrapper>
    )
  }